
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqb54j4bOwQ_SHvP7No8IRpynYxLMxmTHLxt7ZrSuQnzMMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue?macro=true";
import { default as W2ATjsUHt9n1J1RQLh_45r9oSLlX79uqcQmSDVJ7gKhazhnIMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue?macro=true";
import { default as indexJH1I3slGuRobmC3B4BegOlnHFyo1NqCLbskw0quWGNEMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue?macro=true";
import { default as invitefzcJ6k8jsJ2G5v_C81hNFdwg9dOv_45g4SKDJCq18i4PgMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue?macro=true";
import { default as paypalJYKLv2ywa4FwL7iFtztS8WIxVJKn3WQBTkn_45reP3TngMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue?macro=true";
import { default as stripenb5lEWVUaVQmIgDu_45A1HErv7JTaTWiSpa5pxPgV9lLwMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue?macro=true";
import { default as index0a9IdKMiCpHnRtlACX_45Cdw5gf63EMulDrpgGAkPMlzcMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue?macro=true";
import { default as paypalresultJp3Wy3JHhMo8ab6F_4525yWyAOdCyGZXhrkP2FM3PrWD4Meta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue?macro=true";
import { default as striperesultuMW9_45oa1LhypZMfJzs5mLsl_451P9_lxatoY4JvJEjuecMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue?macro=true";
import { default as component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta } from "/var/lib/jenkins/workspace/blink-nuxt-h5/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0.3.2_eslint@9.29.0_jiti@2.4.2_b86df5b6c55daef957f0fcae9a86b923/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI } from "/var/lib/jenkins/workspace/blink-nuxt-h5/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0.3.2_eslint@9.29.0_jiti@2.4.2_b86df5b6c55daef957f0fcae9a86b923/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "faq___en",
    path: "/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___zh-hant-hk",
    path: "/zh-hant-hk/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___ja",
    path: "/ja/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___ko",
    path: "/ko/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___zh",
    path: "/zh/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___id",
    path: "/id/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___it",
    path: "/it/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___ar",
    path: "/ar/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___th",
    path: "/th/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___de",
    path: "/de/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___fr",
    path: "/fr/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___pt",
    path: "/pt/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___tr",
    path: "/tr/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "faq___hi",
    path: "/hi/faq",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/faq.vue")
  },
  {
    name: "W2A___en",
    path: "/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___zh-hant-hk",
    path: "/zh-hant-hk/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___es",
    path: "/es/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___ja",
    path: "/ja/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___ko",
    path: "/ko/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___zh",
    path: "/zh/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___id",
    path: "/id/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___it",
    path: "/it/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___ar",
    path: "/ar/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___th",
    path: "/th/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___de",
    path: "/de/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___ru",
    path: "/ru/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___fr",
    path: "/fr/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___pt",
    path: "/pt/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___tr",
    path: "/tr/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "W2A___hi",
    path: "/hi/W2A",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/W2A.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___zh-hant-hk",
    path: "/zh-hant-hk",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/index.vue")
  },
  {
    name: "invite___en",
    path: "/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___zh-hant-hk",
    path: "/zh-hant-hk/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___es",
    path: "/es/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___ja",
    path: "/ja/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___ko",
    path: "/ko/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___zh",
    path: "/zh/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___id",
    path: "/id/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___it",
    path: "/it/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___ar",
    path: "/ar/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___th",
    path: "/th/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___de",
    path: "/de/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___ru",
    path: "/ru/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___fr",
    path: "/fr/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___pt",
    path: "/pt/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___tr",
    path: "/tr/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "invite___hi",
    path: "/hi/invite",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/invite.vue")
  },
  {
    name: "paypal___en",
    path: "/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___zh-hant-hk",
    path: "/zh-hant-hk/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___es",
    path: "/es/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___ja",
    path: "/ja/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___ko",
    path: "/ko/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___zh",
    path: "/zh/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___id",
    path: "/id/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___it",
    path: "/it/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___ar",
    path: "/ar/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___th",
    path: "/th/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___de",
    path: "/de/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___ru",
    path: "/ru/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___fr",
    path: "/fr/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___pt",
    path: "/pt/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___tr",
    path: "/tr/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "paypal___hi",
    path: "/hi/paypal",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypal.vue")
  },
  {
    name: "stripe___en",
    path: "/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___zh-hant-hk",
    path: "/zh-hant-hk/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___es",
    path: "/es/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___ja",
    path: "/ja/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___ko",
    path: "/ko/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___zh",
    path: "/zh/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___id",
    path: "/id/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___it",
    path: "/it/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___ar",
    path: "/ar/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___th",
    path: "/th/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___de",
    path: "/de/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___ru",
    path: "/ru/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___fr",
    path: "/fr/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___pt",
    path: "/pt/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___tr",
    path: "/tr/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "stripe___hi",
    path: "/hi/stripe",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/stripe.vue")
  },
  {
    name: "tips___en",
    path: "/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___zh-hant-hk",
    path: "/zh-hant-hk/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___es",
    path: "/es/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___ja",
    path: "/ja/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___ko",
    path: "/ko/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___zh",
    path: "/zh/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___id",
    path: "/id/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___it",
    path: "/it/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___ar",
    path: "/ar/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___th",
    path: "/th/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___de",
    path: "/de/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___ru",
    path: "/ru/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___fr",
    path: "/fr/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___pt",
    path: "/pt/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___tr",
    path: "/tr/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "tips___hi",
    path: "/hi/tips",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/tips/index.vue")
  },
  {
    name: "paypalresult___en",
    path: "/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___zh-hant-hk",
    path: "/zh-hant-hk/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___es",
    path: "/es/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___ja",
    path: "/ja/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___ko",
    path: "/ko/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___zh",
    path: "/zh/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___id",
    path: "/id/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___it",
    path: "/it/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___ar",
    path: "/ar/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___th",
    path: "/th/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___de",
    path: "/de/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___ru",
    path: "/ru/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___fr",
    path: "/fr/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___pt",
    path: "/pt/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___tr",
    path: "/tr/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "paypalresult___hi",
    path: "/hi/paypalresult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/paypalresult.vue")
  },
  {
    name: "striperesult___en",
    path: "/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___zh-hant-hk",
    path: "/zh-hant-hk/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___es",
    path: "/es/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___ja",
    path: "/ja/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___ko",
    path: "/ko/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___zh",
    path: "/zh/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___id",
    path: "/id/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___it",
    path: "/it/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___ar",
    path: "/ar/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___th",
    path: "/th/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___de",
    path: "/de/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___ru",
    path: "/ru/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___fr",
    path: "/fr/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___pt",
    path: "/pt/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___tr",
    path: "/tr/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: "striperesult___hi",
    path: "/hi/striperesult",
    component: () => import("/var/lib/jenkins/workspace/blink-nuxt-h5/pages/striperesult.vue")
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/zh-hant-hk/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/ja/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/ko/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/zh/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/id/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/th/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/tr/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  },
  {
    name: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAIMeta?.name,
    path: "/hi/sitemap.xml",
    component: component_45stubMN_iCTaQqtAg0Jk9JsCVpq3NzWtu2sE_iXgtUfJ2VAI
  }
]